import type { FaireProductEntity } from "../../entity_types/product";

export const p_66rmrxdmj8: FaireProductEntity = {
  token: "p_66rmrxdmj8",
  type: "product",
  name: "Freeze Dried Dragon Fruit",
  brandToken: "b_d7mymnraud",
  brandName: "Big Green Organic Food",
  imageUrl:
    "https://cdn.faire.com/fastly/6f0ecaf110fcbf42d13d3ee0f754ed1f0417139ecf41dd9f621d25e198d3125a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89b2c961b7c387d096b23348b9d8c91b4a3a5c0530a8d49b44d0dfa703e38780.png",
    "https://cdn.faire.com/fastly/076924104a328cc068e85a92028c723eea26ed65a999fc3b7353053bfd4adeff.jpeg",
    "https://cdn.faire.com/fastly/ff893d0b48d9dec2fbeabaea48d86e37949664199fdbbf569e79d794aa8666f9.jpeg",
  ],
  priceDollars: 1.94,
  description:
    "Net Weight: 0.7oz (20g)\n\nIngredients: Dragon Fruit\n\nServing Suggestion: Ready to eat, straight from the bag\n\nStorage Instructions: Store in a cool, dry place\n\nRich in dragon fruit fragrance | Crispy texture | Freeze-dried (FD) | Not fried\n\nMade from carefully selected fresh dragon fruits with no preservatives, artificial additives, or added sugar\nUses advanced freeze-drying technology to prevent protein denaturation or microbial degradation, preserving the dragon fruits' original flavor, color, and nutritional value to the greatest extent possible",
  tags: [],
  msrpDollars: 3.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:14.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
